import { useTheme } from '@mui/material';

export const useSxStyles = () => {
  const theme = useTheme();

  const tabContentMaxWidth = '1000px';

  return {
    reportContent: {
      padding: theme.spacing(1, 2),
    },
    tabContent: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(1.5),
      backgroundColor: theme.palette.background.paper,
      padding: theme.spacing(2),
    },
    tabHeading: {
      maxWidth: tabContentMaxWidth,
      textAlign: 'center',
    },
    table: {
      maxWidth: tabContentMaxWidth,
    },
    chartContainer: {
      height: '350px',
      width: '100%',
      maxWidth: tabContentMaxWidth,
      position: 'relative',
    },
    yearNavigation: {
      width: '100%',
      maxWidth: tabContentMaxWidth,
      display: 'flex',
      justifyContent: 'space-between',
    },
    lineTooltipPaper: {
      padding: theme.spacing(0.5),
    },
    lineTooltipPoint: {
      display: 'flex',
      flexDirection: 'row',
      gap: theme.spacing(0.5),
      alignItems: 'center',
    },
    lineTooltipPointColor: {
      fontSize: 'inherit',
    },
  };
};
